import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {AnswerCompleteness} from '../../rfi-individual-results.calc';

@Component({
  selector: 'app-rfi-answer-completeness',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe],
  host: {class: 'text-muted-color text-sm'},
  templateUrl: './rfi-answer-completeness.component.html',
})
export class RfiAnswerCompletenessComponent {
  readonly completeness = input.required<AnswerCompleteness>();
}
